<agpr-dialog-container
    id="briefing.generatingPdfDialog"
    heading="Briefing.pdf.generate"
    [showClose]="false"
>
    <!-- (close)="closeDialog()" -->
    <div class="agpr-generatingPdfDialog-content">
        @if (!confirmGenerate) {
            <div class="agpr-generatingPdfDialog-exportingConfirm">
                @if (!this.isClean) {
                    <div [innerHTML]="('briefing.pdf.unsavedChanges' | localize)"></div>
                    <br/>
                }
                <div [innerHTML]="('Briefing.pdf.generate.confirm.message' | localize) | sanitizeHtml"></div>
            </div>
        } @else {
            <div class="agpr-generatingPdfDialog-exportingContent">
                <span class="fa-duotone fa-regular fa-file-pdf agpr-generatingPdfDialog-exportingIcon" aria-hidden="true"></span>
                <div>
                    <div class="agpr-generatingPdfDialog-exportingDescription">{{ 'Briefing.pdf.generating.message' | localize }}</div>
                </div>
                <div class="agpr-generatingPdfDialog-exportingProgressBar">

                    <p-progressBar
                        [value]="((progress?.currentIndex / progress?.totalItems) * 100)"
                        [showValue]="false"
                    ></p-progressBar>
                </div>
            </div>
        }
    </div>
    <ng-template #footerLeft>
        @if (!confirmGenerate) {
            <agpr-button
                id="briefing.preview.closeDialog"
                [label]="confirmGenerate ? 'briefing.pdf.stopGeneratingPdf' : 'cancel'"
                [style]="buttonTypes.secondary"
                (click)="closeDialog()"
            ></agpr-button>
        } @else {
            <agpr-button
                id="briefing.preview.closeDialog"
                label="briefing.pdf.stopGeneratingPdf"
                [style]="buttonTypes.secondary"
                (click)="closeDialog()"
            ></agpr-button>
        }
    </ng-template>
    @if (!confirmGenerate) {
        <ng-template #footerRight>
            <agpr-button
                id="briefing.pdf.generate"
                [label]="isClean ? 'Briefing.pdf.generate' : 'Briefing.pdf.saveGenerate'"
                [style]="buttonTypes.primary"
                (click)="confirm()"
            ></agpr-button>
        </ng-template>
    }
</agpr-dialog-container>
